<template>
    <div ref="chartdiv" class="chart" style="width: 100%; height: 100%"></div>
</template>
<script setup>
import { ref, onMounted, defineProps } from 'vue';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

const chartdiv = ref(null);
const props = defineProps({
    LiteratureLineData: [],
    NonLiteratureLineData: [],
    LiteratureStickData: [],
    NonLiteratureSticData: [],
});

onMounted(() => {
    //2023-01-01 pby 재반영 확인
    let data = [];
    let deepening = 0;
    let mainPoint = 0;
    let basic = 0;
    if (props.LiteratureLineData !== undefined) {
        deepening = props.LiteratureLineData.deepening;
        mainPoint = props.LiteratureLineData.mainPoint;
        basic = props.LiteratureLineData.basic;
    } else if (props.NonLiteratureLineData !== undefined) {
        deepening = props.NonLiteratureLineData.deepening;
        mainPoint = props.NonLiteratureLineData.mainPoint;
        basic = props.NonLiteratureLineData.basic;
    } else if (props.LiteratureStickData !== undefined) {
        deepening = props.LiteratureStickData.deepening;
        mainPoint = props.LiteratureStickData.mainPoint;
        basic = props.LiteratureStickData.basic;
    } else {
        deepening = props.NonLiteratureSticData.deepening;
        mainPoint = props.NonLiteratureSticData.mainPoint;
        basic = props.NonLiteratureSticData.basic;
    }
    //2023-01-01 pby 재반영 확인
    data.push(
        {
            category: '심화',
            value: deepening,
        },
        {
            category: '핵심',
            value: mainPoint,
        },
        {
            category: '기초',
            value: basic,
        },
    );
    let root = am5.Root.new(chartdiv?.value);
    root.setThemes([am5themes_Animated.new(root)]);
    let chart = root.container.children.push(
        am5xy.XYChart.new(root, {
            layout: root.verticalLayout,
            paddingTop: 40,
        }),
    );
    //2023-01-01 pby 재반영 확인
    let xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 50 });
    xRenderer.labels.template.setAll({
        paddingTop: 5,
        fontSize: 15,
        fontWeight: 'bold',
    });

    let xAxis = chart.xAxes.push(
        am5xy.CategoryAxis.new(root, {
            categoryField: 'category',
            renderer: xRenderer,
        }),
    );

    xAxis.data.setAll(data);

    let series;
    let yAxis = chart.yAxes.push(
        am5xy.ValueAxis.new(root, {
            min: 0,
            max: 100,
            paddingBottom: 10,
            renderer: am5xy.AxisRendererY.new(root, { minGridDistance: 40 }),
        }),
    );

    if (props.LiteratureLineData !== undefined || props.NonLiteratureLineData !== undefined) {
        series = chart.series.push(
            am5xy.LineSeries.new(root, {
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: 'value',
                categoryXField: 'category',
                stroke: am5.color(0x18b73f),
                maskBullets: false,
            }),
        );
    } else {
        series = chart.series.push(
            am5xy.ColumnSeries.new(root, {
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: 'value',
                categoryXField: 'category',
                fill: 'red',
                maskBullets: false,
            }),
        );
        series.columns.template.setAll({
            width: 20,
            fill: am5.color('#18b73f'),
            strokeWidth: 2,
            cornerRadiusTL: 30,
            cornerRadiusTR: 30,
        });
    }
    //2023-01-01 pby 재반영 확인
    series.bullets.push(function () {
        return am5.Bullet.new(root, {
            locationY: 1,
            locationX: 0.5,
            sprite: am5.Label.new(root, {
                text: "[fontWeight:700]{valueYWorking.formatNumber('#.')}%",
                centerY: am5.p100,
                centerX: am5.p50,
                populateText: true,
            }),
        });
    });
    if (props.LiteratureLineData !== undefined || props.NonLiteratureLineData !== undefined) {
        series.bullets.push(function () {
            return am5.Bullet.new(root, {
                sprite: am5.Circle.new(root, {
                    fill: am5.color(0x18b73f),
                    radius: 5,
                }),
            });
        });
    }
    //2023-01-01 pby 재반영 확인
    series.data.setAll(data);
    series.appear(2000);
    chart.appear(1000, 100);
});
</script>
<style lang="scss" scoped>
@media print {
    .chart {
        ::v-deep > div {
            display: flex;
            justify-content: center;
        }
        ::v-deep canvas {
            width: 100% !important;
            height: 100% !important;
            top: 50% !important;
            left: 50% !important;
            transform: translate(-50%, -50%);
        }
    }
}
</style>
